export default "/dist/hic/static/media/NationalWeb-Bold.woff";